import { render, staticRenderFns } from "./Web.vue?vue&type=template&id=4e625566&scoped=true"
import script from "./Web.vue?vue&type=script&lang=js"
export * from "./Web.vue?vue&type=script&lang=js"
import style0 from "./Web.vue?vue&type=style&index=0&id=4e625566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e625566",
  null
  
)

export default component.exports